import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { CfagStore } from '../stores/cfag.store';

export const CfagSummaryGuard: CanMatchFn = () => {
  const perStore = inject(CfagStore);
  const router = inject(Router);

  if (!perStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['cfag', 'cfag-form']);
  }

  return true;
};
